export enum UserGroups {
	ADMIN = 'travelnest-internal',
	ADMIN_PROPERTY_EDITOR = 'admin-property-editor',
	ADMIN_CUSTOMER_EDITOR = 'admin-customer-editor',
	ADMIN_LISTING_EDITOR = 'admin-listing-editor',
	ADMIN_DISTRIBUTION_EDITOR = 'admin-distribution-editor',
	ADMIN_BOOKING_EDITOR = 'admin-booking-editor',
	ADMIN_BOOKINGCOM_EDITOR = 'admin-bookingcom-editor',

	PROPERTY_CREATOR = 'property-creator',
	AVAILABILITY_EDITOR = 'availability-editor',
	PRICING_EDITOR = 'pricing-editor'
}
